import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScFeature = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  & > .icon {
    background-color: ${({ theme }) => theme.whiteColor};
    width: 56px;
    height: 56px;
    border-radius: 40px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  & > .text {
    text-align: center;
    font-size: 16px;
    line-height: 1.25;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    font-weight: bold;
    max-width: 160px;
  }

  @media (${device.mobile}) {
    flex-direction: row;

    & > .icon {
      width: 48px;
      height: 48px;
      background-color: ${({ theme }) => theme.whiteColor};
      border-radius: 40px;
    }

    & > .text {
      text-align: left;
    }
  }
`;
